/** @format */

import {Trans} from 'react-i18next';

import {HelpContentBox, HelpContentText} from '../../styles';

const CabinetHelpContent = (
  <HelpContentBox>
    <HelpContentText>
      <Trans>
        Рекламным кабинетом в AdSensor называется любой аккаунт в системе Яндекс Директ, как обычный
        клиентский аккаунт, так и управляющий (агентский).
      </Trans>
    </HelpContentText>
    <HelpContentText>
      <Trans>
        Управляющий аккаунт Яндекс Директ — это специальный аккаунт для централизованного управления
        несколькими рекламными клиентскими аккаунтами. Чаще всего используется диджитал-агентствами.
      </Trans>
    </HelpContentText>
    <HelpContentText>
      <Trans>
        Любой тип аккаунта Яндекс Директ при подключении к AdSensor занимает одно место рекламного
        кабинета, предусмотренного в рамках вашего тарифного плана.
      </Trans>
    </HelpContentText>
    <HelpContentText>
      <Trans>
        В случае необходимости можно приобрести возможность подключения дополнительного рекламного
        кабинета по фиксированной цене на момент возникновения запроса.
      </Trans>
    </HelpContentText>
  </HelpContentBox>
);

export {CabinetHelpContent};
